import { render } from "./SuspendedView.vue?vue&type=template&id=8abfe89c&scoped=true&ts=true"
import script from "./SuspendedView.vue?vue&type=script&lang=ts"
export * from "./SuspendedView.vue?vue&type=script&lang=ts"

import "./SuspendedView.vue?vue&type=style&index=0&id=8abfe89c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abfe89c"]])

export default __exports__